import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-block",
  templateUrl: "./med-icon-block.component.html",
})
export class MedIconBlockComponent extends SvgMixinComponent {}
